/**
 * Mapa kodów pocztowych do województw w Polsce
 * Automatyczne wykrywanie województwa na podstawie kodu pocztowego
 */

// Mapowanie pierwszych 2 cyfr kodu pocztowego na województwo
const postalCodeToVoivodeship = {
  '00': 'mazowieckie', '01': 'mazowieckie', '02': 'mazowieckie', '03': 'mazowieckie', '04': 'mazowieckie',
  '05': 'mazowieckie', '06': 'mazowieckie', '07': 'mazowieckie', '08': 'mazowieckie', '09': 'mazowieckie',
  '10': 'warmińsko-mazurskie', '11': 'warmińsko-mazurskie', '12': 'warmińsko-mazurskie', '13': 'warmińsko-mazurskie', '14': 'warmińsko-mazurskie',
  '15': 'podlaskie', '16': 'podlaskie', '17': 'podlaskie', '18': 'podlaskie', '19': 'podlaskie',
  '20': 'lubelskie', '21': 'lubelskie', '22': 'lubelskie', '23': 'lubelskie', '24': 'lubelskie',
  '25': 'świętokrzyskie', '26': 'świętokrzyskie', '27': 'świętokrzyskie', '28': 'świętokrzyskie', '29': 'świętokrzyskie',
  '30': 'małopolskie', '31': 'małopolskie', '32': 'małopolskie', '33': 'małopolskie', '34': 'małopolskie',
  '35': 'podkarpackie', '36': 'podkarpackie', '37': 'podkarpackie', '38': 'podkarpackie', '39': 'podkarpackie',
  '40': 'śląskie', '41': 'śląskie', '42': 'śląskie', '43': 'śląskie', '44': 'śląskie',
  '45': 'opolskie', '46': 'opolskie', '47': 'opolskie', '48': 'opolskie', '49': 'opolskie',
  '50': 'dolnośląskie', '51': 'dolnośląskie', '52': 'dolnośląskie', '53': 'dolnośląskie', '54': 'dolnośląskie',
  '55': 'dolnośląskie', '56': 'dolnośląskie', '57': 'dolnośląskie', '58': 'dolnośląskie', '59': 'dolnośląskie',
  '60': 'wielkopolskie', '61': 'wielkopolskie', '62': 'wielkopolskie', '63': 'wielkopolskie', '64': 'wielkopolskie',
  '65': 'lubuskie', '66': 'lubuskie', '67': 'lubuskie', '68': 'lubuskie', '69': 'lubuskie',
  '70': 'zachodniopomorskie', '71': 'zachodniopomorskie', '72': 'zachodniopomorskie', '73': 'zachodniopomorskie', '74': 'zachodniopomorskie',
  '75': 'zachodniopomorskie', '76': 'pomorskie', '77': 'pomorskie', '78': 'zachodniopomorskie',
  '80': 'pomorskie', '81': 'pomorskie', '82': 'pomorskie', '83': 'pomorskie', '84': 'pomorskie',
  '85': 'kujawsko-pomorskie', '86': 'kujawsko-pomorskie', '87': 'kujawsko-pomorskie', '88': 'kujawsko-pomorskie', '89': 'kujawsko-pomorskie',
  '90': 'łódzkie', '91': 'łódzkie', '92': 'łódzkie', '93': 'łódzkie', '94': 'łódzkie',
  '95': 'łódzkie', '96': 'łódzkie', '97': 'łódzkie', '98': 'łódzkie', '99': 'łódzkie',
};

/**
 * Pobiera województwo na podstawie kodu pocztowego
 * @param {string} postalCode - Kod pocztowy (format XX-XXX lub XXXXX)
 * @returns {string|null} - Województwo lub null jeśli nie znaleziono
 */
export const getVoivodeshipFromPostalCode = (postalCode) => {
  if (!postalCode) return null;
  
  // Usuń myślnik i spacje
  const cleaned = postalCode.replace(/[-\s]/g, '');
  
  // Sprawdź czy ma 5 cyfr
  if (!/^\d{5}$/.test(cleaned)) return null;
  
  // Pobierz pierwsze 2 cyfry
  const prefix = cleaned.substring(0, 2);
  
  return postalCodeToVoivodeship[prefix] || null;
};

/**
 * Formatuje kod pocztowy do formatu XX-XXX
 * @param {string} value - Wartość do sformatowania
 * @returns {string} - Sformatowany kod pocztowy
 */
export const formatPostalCode = (value) => {
  if (!value) return '';
  
  // Usuń wszystko poza cyframi
  const digits = value.replace(/\D/g, '');
  
  // Ogranicz do 5 cyfr
  const limited = digits.substring(0, 5);
  
  // Dodaj myślnik po 2 cyfrach
  if (limited.length > 2) {
    return `${limited.substring(0, 2)}-${limited.substring(2)}`;
  }
  
  return limited;
};

/**
 * Waliduje kod pocztowy
 * @param {string} postalCode - Kod pocztowy do walidacji
 * @returns {boolean} - Czy kod jest poprawny
 */
export const isValidPostalCode = (postalCode) => {
  if (!postalCode) return false;
  const cleaned = postalCode.replace(/[-\s]/g, '');
  return /^\d{5}$/.test(cleaned);
};

/**
 * Formatuje pełny adres do wyświetlenia
 * @param {object} address - Obiekt z danymi adresowymi
 * @returns {string} - Sformatowany adres
 */
export const formatFullAddress = (address) => {
  const parts = [];
  
  if (address.street) {
    let streetPart = address.street;
    if (address.house_number) {
      streetPart += ` ${address.house_number}`;
    }
    parts.push(streetPart);
  }
  
  if (address.postal_code || address.city) {
    let cityPart = '';
    if (address.postal_code) {
      cityPart = address.postal_code;
    }
    if (address.city) {
      cityPart += cityPart ? ` ${address.city}` : address.city;
    }
    if (cityPart) parts.push(cityPart);
  }
  
  return parts.join(', ');
};

export default {
  getVoivodeshipFromPostalCode,
  formatPostalCode,
  isValidPostalCode,
  formatFullAddress,
};
